import { ICreateSoftware } from '../../software/types';

export const SOFTWARE_FORM_INITIAL_STATE: ICreateSoftware = {
  title: '',
  description: '',
  logo: '',
  link: '',
};
